import { Link } from "react-router-dom";
import logo from "./logo.png";
import {
	Phone,
	Mail,
	MapPin,
	Facebook,
	Instagram,
	MessageCircle,
} from "lucide-react";

export default function Footer() {
	return (
		<footer className="bg-gradient-to-b from-slate-900 to-slate-950 text-white pt-16 pb-8">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 mb-12">
					{/* About */}
					<div>
						<div className="flex items-center space-x-4 mb-6">
							<img
								src={logo}
								alt="Blue Oyster"
								className="h-[80px] w-[80px] object-contain brightness-0 invert"
							/>
							<h3
								className="text-2xl font-bold"
								style={{ fontFamily: "Cormorant Garamond, serif" }}
							>
								Blue Oyster
							</h3>
						</div>
						<p className="text-gray-400 text-sm leading-relaxed">
							Морепродукты высшего качества, доставляемые в термоизолированных
							ящиках. Прямые поставки от проверенных производителей.
						</p>
					</div>

					{/* Quick Links */}
					<div>
						<h4
							className="text-lg font-semibold mb-6"
							style={{ fontFamily: "Cormorant Garamond, serif" }}
						>
							Навигация
						</h4>
						<ul className="space-y-2">
							<li>
								<Link
									to="/catalog"
									className="text-gray-400 hover:text-sky-400 transition-colors"
								>
									Каталог
								</Link>
							</li>
							<li>
								<Link
									to="/about"
									className="text-gray-400 hover:text-sky-400 transition-colors"
								>
									О нас
								</Link>
							</li>
							<li>
								<Link
									to="/delivery"
									className="text-gray-400 hover:text-sky-400 transition-colors"
								>
									Доставка и оплата
								</Link>
							</li>
							<li>
								<Link
									to="/promotions"
									className="text-gray-400 hover:text-sky-400 transition-colors"
								>
									Акции
								</Link>
							</li>
							<li>
								<Link
									to="/contacts"
									className="text-gray-400 hover:text-sky-400 transition-colors"
								>
									Контакты
								</Link>
							</li>
						</ul>
					</div>

					{/* Contact */}
					<div>
						<h4
							className="text-lg font-semibold mb-6"
							style={{ fontFamily: "Cormorant Garamond, serif" }}
						>
							Связаться с нами
						</h4>

						<ul className="flex flex-row items-center gap-4">
							<li>
								<a
									href="https://instagram.com/blueoyster"
									target="_blank"
									rel="noopener noreferrer"
									className="inline-flex items-center justify-center w-11 h-11 rounded-full border border-slate-700 hover:bg-slate-800 hover:border-sky-400 transition-colors"
								>
									<Instagram className="w-5 h-5 text-sky-400" />
								</a>
							</li>
							<li>
								<a
									href="https://t.me/blueoyster"
									target="_blank"
									rel="noopener noreferrer"
									className="inline-flex items-center justify-center w-11 h-11 rounded-full border border-slate-700 hover:bg-slate-800 hover:border-sky-400 transition-colors"
								>
									<MessageCircle className="w-5 h-5 text-sky-400" />
								</a>
							</li>
						</ul>
					</div>
				</div>

				<div className="border-t border-slate-800 pt-8">
					<div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
						<p className="text-gray-500 text-sm">
							© 2025 Blue Oyster. All rights reserved.
						</p>
						<div className="flex space-x-6 text-sm">
							<a
								href="#"
								className="text-gray-500 hover:text-sky-400 transition-colors"
							>
								Privacy Policy
							</a>
							<a
								href="#"
								className="text-gray-500 hover:text-sky-400 transition-colors"
							>
								Terms of Service
							</a>
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
}
